var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatenote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 11.4297H1.96875C1.72676 11.4297 1.53125 11.6252 1.53125 11.8672V12.3594C1.53125 12.4195 1.58047 12.4688 1.64062 12.4688H12.3594C12.4195 12.4688 12.4688 12.4195 12.4688 12.3594V11.8672C12.4688 11.6252 12.2732 11.4297 12.0312 11.4297ZM3.52324 10.2812C3.55059 10.2812 3.57793 10.2785 3.60527 10.2744L5.90488 9.87109C5.93223 9.86563 5.9582 9.85332 5.97734 9.83281L11.7729 4.0373C11.7855 4.02466 11.7956 4.00963 11.8024 3.99309C11.8093 3.97655 11.8128 3.95882 11.8128 3.94092C11.8128 3.92301 11.8093 3.90528 11.8024 3.88874C11.7956 3.8722 11.7855 3.85718 11.7729 3.84453L9.50059 1.5709C9.47461 1.54492 9.44043 1.53125 9.40352 1.53125C9.3666 1.53125 9.33242 1.54492 9.30645 1.5709L3.51094 7.36641C3.49043 7.38691 3.47812 7.41152 3.47266 7.43887L3.06934 9.73848C3.05604 9.81172 3.06079 9.8871 3.08318 9.95809C3.10557 10.0291 3.14493 10.0935 3.19785 10.1459C3.28809 10.2334 3.40156 10.2812 3.52324 10.2812Z",
    fill: "#1581E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatenote);
export default __webpack_public_path__ + "static/media/createnote.219d0187910f80049ebb8ae711004435.svg";
export { ForwardRef as ReactComponent };